// The fetch the Supabase client uses. Identical to the browser's fetch, except that a WRITE to the data or file API
// (insert, update, delete, upsert, a database function) drops everything the pages remembered in memory
// (lib/dataCache.js), when it starts and again when it ends, so no page ever shows a state the write has just
// changed. Sign-in and token-refresh calls are not writes to data and leave the cache alone.
import { invalidateAll, isDataWrite } from './dataCache';

export function makeDataFetch(base: typeof fetch = (...args) => fetch(...args)): typeof fetch {
  return async (input, init) => {
    const target = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    const method = init?.method ?? (typeof input === 'string' || input instanceof URL ? 'GET' : input.method);
    const writes = isDataWrite(target, method);
    if (writes) invalidateAll();
    try {
      return await base(input, init);
    } finally {
      if (writes) invalidateAll();
    }
  };
}
